export default Object.freeze({
  Delegated: 0,
  Deleted: 1,
});
